import type { Column, LayoutContent, LinkedText, NavigationList1 } from '../../../../types/navigationHierarchyData';
import { CategoryFeaturedCard } from '../../CategoryFeaturedCard';
import { NavigationListItem } from '../navigationListItem/NavigationListItem';
import { MenuColumnContainer, MenuColumnContent } from './megaMenuRow.styles';

export function MegaMenuRow({
  layoutContent,
  extendWidth = false,
  handleCloseMenu,
}: {
  layoutContent: LayoutContent | Column[];
  extendWidth?: boolean;
  handleCloseMenu: () => void;
}) {
  const hasFeaturedCards = Boolean(layoutContent?.find((columnData) => 'featuredCards' in columnData));

  return (
    <>
      {layoutContent.map((columnData: Column, columnIndex: number) => {
        const { navigationList, featuredCards } = columnData;

        return (
          <MenuColumnContainer
            role="none"
            key={`column-${columnIndex}`}
            $hasFeaturedCards={hasFeaturedCards}
            $extendWidth={extendWidth}
          >
            {navigationList &&
              navigationList.map((navigationListData: NavigationList1, listIndex: number) => {
                const { featuredLinks, category } = navigationListData;
                const { linkedContentChildData } = featuredLinks || {};
                return (
                  <MenuColumnContent role="none" key={`column-${columnIndex}-featured-${listIndex}`}>
                    {featuredLinks &&
                      linkedContentChildData &&
                      linkedContentChildData?.featuredLinks?.map((featuredLink: LinkedText, linkIndex: number) => (
                        <NavigationListItem
                          navLink={featuredLink}
                          key={`column-${columnIndex}-featured-${listIndex}-content-${linkIndex}`}
                          handleCloseMenu={handleCloseMenu}
                        />
                      ))}
                    {category && category.linkedContentChildData && (
                      <NavigationListItem
                        navLink={category.linkedContentChildData}
                        key={`column-${columnIndex}-category-content-${listIndex}`}
                        handleCloseMenu={handleCloseMenu}
                      />
                    )}
                  </MenuColumnContent>
                );
              })}

            {featuredCards && (
              <CategoryFeaturedCard {...featuredCards.linkedContentChildData} extendWidth={extendWidth} />
            )}
          </MenuColumnContainer>
        );
      })}
    </>
  );
}
